/**
 * @desc MQ消费日志
 */
const URL = "/rantion-aider";
import http, { updateResponse } from "@/http";
export function request(body: defs.aider.ConsumeParamDto, options?: any) {
  return updateResponse(
    http(URL + `/log/message/consume`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
